module.exports = __webpack_public_path__ + "static/media/game-percentage_icon.16768eb2.svg";